import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'

const Details = ({ flow = 'column', bookingAppRedesign = false, ...props }) => (
  <Container data-container="details" flow={flow} bookingAppRedesign={bookingAppRedesign} {...props} />
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row']),
  bookingAppRedesign: PropTypes.bool
}

export default Details
